export enum ArticlePageTypes {
    ARTICLE_PAGE = 'ARTICLE_PAGE',
    CONFIRMATION_PAGE = 'CONFIRMATION_PAGE',
    ARTICLE_PAGE_STRAPIID = 'ARTICLE_PAGE_STRAPIID',
    CONFIRMATION_PAGE_STRAPIID = 'CONFIRMATION_PAGE_STRAPIID'
}
